import React, {useContext} from 'react';
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import {BridleContext} from './BridleContextProvider';
import StartPage from './pages/StartPage';
import Color from './pages/Color';
import Crown from './pages/Crown';
import Browband from './pages/Browband';
import Cheek from './pages/Cheek';
import Noseband from './pages/Noseband';
import Reins from './pages/Reins';
import Review from './pages/Review';
import './styles/pages.scss';
import './styles/actions.scss';

const App = () => {
    const {styles} = useContext(BridleContext);
    const startPageURL = '/bridle-builder';

    if (startPageURL !== location.pathname) {
        if (!styles) {
            location.href = startPageURL;
        }
    }

    return (
        <>
            <div className="bridle-builder-container template-default">
                <Router basename="/bridle-builder">
                    <Routes>
                        <Route path="/" element={<StartPage />} />
                        <Route path="/color" element={<Color />} />
                        <Route path="/crown" element={<Crown />} />
                        <Route path="/browband" element={<Browband />} />
                        <Route path="/cheekpiece" element={<Cheek />} />
                        <Route path="/noseband" element={<Noseband />} />
                        <Route path="/reins" element={<Reins />} />
                        <Route path="/review" element={<Review />} />
                    </Routes>
                </Router>
            </div>
        </>
    );
};

export default App;
